"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneSelectList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * TimezoneSelectList.tsx
 * Author: amusiol
 * Date: 24.02.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const Input_1 = require("./Input");
const react_i18next_1 = require("react-i18next");
const TimezoneSelectList = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [list, setList] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        props.keycloakfetch.get(props.settings.apiUrl + '/getTimeZoneList').then(result => {
            setList(result);
        });
    }, []);
    let input = (0, jsx_runtime_1.jsx)(Input_1.Input, { name: 'timezone', edit: true, label: props.label, value: props.value, dropdownOptions: list, scrollHeight: '350px', type: 'dropdown', tooltip: t('input_tooltip_timezoneSelectList'), onChange: (e) => {
            if (props.onChange)
                props.onChange(e);
        } });
    if (props.validationControl)
        input = (0, jsx_runtime_1.jsx)(Input_1.Input, { name: 'timezone', edit: true, label: props.label, dropdownOptions: list, scrollHeight: '350px', type: 'dropdown', tooltip: t('input_tooltip_timezoneSelectList'), onChange: (e) => {
                if (props.onChange)
                    props.onChange(e);
            }, validationControl: props.validationControl, validationErrorMessage: props.validationErrorMessage, validationRules: props.validationRules });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: input }));
};
exports.TimezoneSelectList = TimezoneSelectList;
